"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    showMore: "Show more...",
    showLess: "Show less...",
};
